const pad = (string, pad, length) => {
    return (new Array(length+1).join(pad)+string).slice(-length);
}

export default pad